import script from "./TicTacToePage.vue?vue&type=script&setup=true&lang=js"
export * from "./TicTacToePage.vue?vue&type=script&setup=true&lang=js"

import "./TicTacToePage.vue?vue&type=style&index=0&id=1f310014&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1f310014"]])

export default __exports__